import {
  useGlobalComponentForAttribute,
  TableInheritedProps
} from '@rhino-project/core/hooks';
import { CellString } from '../../table/cells/CellString';

export const ModelCellStringBase = (props: TableInheritedProps) => (
  <CellString {...props} />
);

export const ModelCellString = (props: TableInheritedProps) =>
  useGlobalComponentForAttribute('ModelCellString', ModelCellStringBase, props);
